import React from "react";
import styled from "styled-components";

export default styled.span`
    color: #5562C0;
    font-weight: 700;
`;